export type CarouselV3AspectRatios = '3:2' | '9:16' | '1:1' | '16:9';
